import React from "react";
import { Flex } from "antd";
import {
  SbRow,
  SbCol,
  SbStatistic,
  BankOutlined,
  ApartmentOutlined,
  ClusterOutlined,
  BranchesOutlined,
} from "uiCore";
import SbCard from "uiCore/SbCard/SbCard";

import { StatIconStyled } from "./LegalEntityManagement.styles";

const STAT_ITEMS = [
  { key: "entities", label: "Legal entities", icon: <BankOutlined /> },
  { key: "bus", label: "Business units", icon: <ApartmentOutlined /> },
  { key: "fns", label: "Functions", icon: <ClusterOutlined /> },
  { key: "subs", label: "Sub-functions", icon: <BranchesOutlined /> },
];

const StatsBar = ({ stats }) => (
  <SbRow gutter={[12, 12]} align="stretch">
    {STAT_ITEMS.map((item) => (
      <SbCol xs={12} sm={12} md={6} key={item.key}>
        <SbCard>
          <Flex align="center" gap={12}>
            <StatIconStyled>{item.icon}</StatIconStyled>
            <SbStatistic title={item.label} value={stats[item.key]} />
          </Flex>
        </SbCard>
      </SbCol>
    ))}
  </SbRow>
);

export default StatsBar;
